export const countries = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua And Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia And Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, Democratic Republic",
  "Cook Islands",
  "Costa Rica",
  'Cote D"Ivoire',
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island & Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic Of",
  "Iraq",
  "Ireland",
  "Isle Of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea",
  "North Korea",
  "Kuwait",
  "Kyrgyzstan",
  'Lao People"s Democratic Republic',
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States Of",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts And Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre And Miquelon",
  "Saint Vincent And Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome And Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia And Sandwich Isl.",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard And Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad And Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks And Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis And Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const countryCodeAndCurrency: Record<
  string,
  { code: string; currency: string | "-" }
> = {
  Afghanistan: { code: "AF", currency: "AFN" },
  "Aland Islands": { code: "AX", currency: "EUR" },
  Albania: { code: "AL", currency: "ALL" },
  Algeria: { code: "DZ", currency: "DZD" },
  "American Samoa": { code: "AS", currency: "USD" },
  Andorra: { code: "AD", currency: "EUR" },
  Angola: { code: "AO", currency: "AOA" },
  Anguilla: { code: "AI", currency: "XCD" },
  Antarctica: { code: "AQ", currency: "-" },
  "Antigua And Barbuda": { code: "AG", currency: "XCD" },
  Argentina: { code: "AR", currency: "ARS" },
  Armenia: { code: "AM", currency: "AMD" },
  Aruba: { code: "AW", currency: "AWG" },
  Australia: { code: "AU", currency: "AUD" },
  Austria: { code: "AT", currency: "EUR" },
  Azerbaijan: { code: "AZ", currency: "AZN" },
  Bahamas: { code: "BS", currency: "BSD" },
  Bahrain: { code: "BH", currency: "BHD" },
  Bangladesh: { code: "BD", currency: "BDT" },
  Barbados: { code: "BB", currency: "BBD" },
  Belarus: { code: "BY", currency: "BYN" },
  Belgium: { code: "BE", currency: "EUR" },
  Belize: { code: "BZ", currency: "BZD" },
  Benin: { code: "BJ", currency: "XOF" },
  Bermuda: { code: "BM", currency: "BMD" },
  Bhutan: { code: "BT", currency: "BTN" },
  Bolivia: { code: "BO", currency: "BOB" },
  "Bosnia And Herzegovina": { code: "BA", currency: "BAM" },
  Botswana: { code: "BW", currency: "BWP" },
  "Bouvet Island": { code: "BV", currency: "NOK" },
  Brazil: { code: "BR", currency: "BRL" },
  "British Indian Ocean Territory": { code: "IO", currency: "USD" },
  "Brunei Darussalam": { code: "BN", currency: "BND" },
  Bulgaria: { code: "BG", currency: "BGN" },
  "Burkina Faso": { code: "BF", currency: "XOF" },
  Burundi: { code: "BI", currency: "BIF" },
  Cambodia: { code: "KH", currency: "KHR" },
  Cameroon: { code: "CM", currency: "XAF" },
  Canada: { code: "CA", currency: "CAD" },
  "Cape Verde": { code: "CV", currency: "CVE" },
  "Cayman Islands": { code: "KY", currency: "KYD" },
  "Central African Republic": { code: "CF", currency: "XAF" },
  Chad: { code: "TD", currency: "XAF" },
  Chile: { code: "CL", currency: "CLP" },
  China: { code: "CN", currency: "CNH" },
  "Christmas Island": { code: "CX", currency: "AUD" },
  "Cocos (Keeling) Islands": { code: "CC", currency: "AUD" },
  Colombia: { code: "CO", currency: "COP" },
  Comoros: { code: "KM", currency: "KMF" },
  Congo: { code: "CG", currency: "CDF" },
  "Congo, Democratic Republic": { code: "CD", currency: "CDF" },
  "Cook Islands": { code: "CK", currency: "NZD" },
  "Costa Rica": { code: "CR", currency: "CRC" },
  'Cote D"Ivoire': { code: "CI", currency: "XOF" },
  Croatia: { code: "HR", currency: "EUR" },
  Cuba: { code: "CU", currency: "CUP" },
  Cyprus: { code: "CY", currency: "EUR" },
  "Czech Republic": { code: "CZ", currency: "CZK" },
  Denmark: { code: "DK", currency: "DKK" },
  Djibouti: { code: "DJ", currency: "DJF" },
  Dominica: { code: "DM", currency: "XCD" },
  "Dominican Republic": { code: "DO", currency: "DOP" },
  Ecuador: { code: "EC", currency: "USD" },
  Egypt: { code: "EG", currency: "EGP" },
  "El Salvador": { code: "SV", currency: "SVC" },
  "Equatorial Guinea": { code: "GQ", currency: "XAF" },
  Eritrea: { code: "ER", currency: "ERN" },
  Estonia: { code: "EE", currency: "EUR" },
  Ethiopia: { code: "ET", currency: "ETB" },
  "Falkland Islands (Malvinas)": { code: "FK", currency: "FKP" },
  "Faroe Islands": { code: "FO", currency: "DKK" },
  Fiji: { code: "FJ", currency: "FJD" },
  Finland: { code: "FI", currency: "EUR" },
  France: { code: "FR", currency: "EUR" },
  "French Guiana": { code: "GF", currency: "EUR" },
  "French Polynesia": { code: "PF", currency: "XPF" },
  "French Southern Territories": { code: "TF", currency: "EUR" },
  Gabon: { code: "GA", currency: "XAF" },
  Gambia: { code: "GM", currency: "GMD" },
  Georgia: { code: "GE", currency: "GEL" },
  Germany: { code: "DE", currency: "EUR" },
  Ghana: { code: "GH", currency: "GHS" },
  Gibraltar: { code: "GI", currency: "GIP" },
  Greece: { code: "GR", currency: "EUR" },
  Greenland: { code: "GL", currency: "DKK" },
  Grenada: { code: "GD", currency: "XCD" },
  Guadeloupe: { code: "GP", currency: "EUR" },
  Guam: { code: "GU", currency: "USD" },
  Guatemala: { code: "GT", currency: "GTQ" },
  Guernsey: { code: "GG", currency: "GBP" },
  Guinea: { code: "GN", currency: "GNF" },
  "Guinea-Bissau": { code: "GW", currency: "XOF" },
  Guyana: { code: "GY", currency: "GYD" },
  Haiti: { code: "HT", currency: "HTG" },
  "Heard Island & Mcdonald Islands": { code: "HM", currency: "AUD" },
  "Holy See (Vatican City State)": { code: "VA", currency: "EUR" },
  Honduras: { code: "HN", currency: "HNL" },
  "Hong Kong": { code: "HK", currency: "HKD" },
  Hungary: { code: "HU", currency: "HUF" },
  Iceland: { code: "IS", currency: "ISK" },
  India: { code: "IN", currency: "INR" },
  Indonesia: { code: "ID", currency: "IDR" },
  "Iran, Islamic Republic Of": { code: "IR", currency: "IRR" },
  Iraq: { code: "IQ", currency: "IQD" },
  Ireland: { code: "IE", currency: "EUR" },
  "Isle Of Man": { code: "IM", currency: "GBP" },
  Israel: { code: "IL", currency: "ILS" },
  Italy: { code: "IT", currency: "EUR" },
  Jamaica: { code: "JM", currency: "JMD" },
  Japan: { code: "JP", currency: "JPY" },
  Jersey: { code: "JE", currency: "GBP" },
  Jordan: { code: "JO", currency: "JOD" },
  Kazakhstan: { code: "KZ", currency: "KZT" },
  Kenya: { code: "KE", currency: "KES" },
  Kiribati: { code: "KI", currency: "AUD" },
  Korea: { code: "KR", currency: "KRW" },
  "North Korea": { code: "KP", currency: "KPW" },
  Kuwait: { code: "KW", currency: "KWD" },
  Kyrgyzstan: { code: "KG", currency: "KGS" },
  'Lao People"s Democratic Republic': { code: "LA", currency: "LAK" },
  Latvia: { code: "LV", currency: "EUR" },
  Lebanon: { code: "LB", currency: "LBP" },
  Lesotho: { code: "LS", currency: "LSL" },
  Liberia: { code: "LR", currency: "LRD" },
  "Libyan Arab Jamahiriya": { code: "LY", currency: "LYD" },
  Liechtenstein: { code: "LI", currency: "CHF" },
  Lithuania: { code: "LT", currency: "EUR" },
  Luxembourg: { code: "LU", currency: "EUR" },
  Macao: { code: "MO", currency: "MOP" },
  Macedonia: { code: "MK", currency: "MKD" },
  Madagascar: { code: "MG", currency: "MGA" },
  Malawi: { code: "MW", currency: "MWK" },
  Malaysia: { code: "MY", currency: "MYR" },
  Maldives: { code: "MV", currency: "MVR" },
  Mali: { code: "ML", currency: "XOF" },
  Malta: { code: "MT", currency: "EUR" },
  "Marshall Islands": { code: "MH", currency: "USD" },
  Martinique: { code: "MQ", currency: "EUR" },
  Mauritania: { code: "MR", currency: "MRO" },
  Mauritius: { code: "MU", currency: "MUR" },
  Mayotte: { code: "YT", currency: "EUR" },
  Mexico: { code: "MX", currency: "MXN" },
  "Micronesia, Federated States Of": { code: "FM", currency: "USD" },
  Moldova: { code: "MD", currency: "MDL" },
  Monaco: { code: "MC", currency: "EUR" },
  Mongolia: { code: "MN", currency: "MNT" },
  Montenegro: { code: "ME", currency: "EUR" },
  Montserrat: { code: "MS", currency: "XCD" },
  Morocco: { code: "MA", currency: "MAD" },
  Mozambique: { code: "MZ", currency: "MZN" },
  Myanmar: { code: "MM", currency: "MMK" },
  Namibia: { code: "NA", currency: "NAD" },
  Nauru: { code: "NR", currency: "AUD" },
  Nepal: { code: "NP", currency: "NPR" },
  Netherlands: { code: "NL", currency: "EUR" },
  "Netherlands Antilles": { code: "AN", currency: "ANG" },
  "New Caledonia": { code: "NC", currency: "XPF" },
  "New Zealand": { code: "NZ", currency: "NZD" },
  Nicaragua: { code: "NI", currency: "NIO" },
  Niger: { code: "NE", currency: "XOF" },
  Nigeria: { code: "NG", currency: "NGN" },
  Niue: { code: "NU", currency: "NZD" },
  "Norfolk Island": { code: "NF", currency: "AUD" },
  "Northern Mariana Islands": { code: "MP", currency: "USD" },
  Norway: { code: "NO", currency: "NOK" },
  Oman: { code: "OM", currency: "OMR" },
  Pakistan: { code: "PK", currency: "PKR" },
  Palau: { code: "PW", currency: "USD" },
  "Palestinian Territory, Occupied": { code: "PS", currency: "ILS" },
  Panama: { code: "PA", currency: "PAB" },
  "Papua New Guinea": { code: "PG", currency: "PGK" },
  Paraguay: { code: "PY", currency: "PYG" },
  Peru: { code: "PE", currency: "PEN" },
  Philippines: { code: "PH", currency: "PHP" },
  Pitcairn: { code: "PN", currency: "NZD" },
  Poland: { code: "PL", currency: "PLN" },
  Portugal: { code: "PT", currency: "EUR" },
  "Puerto Rico": { code: "PR", currency: "USD" },
  Qatar: { code: "QA", currency: "QAR" },
  Reunion: { code: "RE", currency: "EUR" },
  Romania: { code: "RO", currency: "RON" },
  "Russian Federation": { code: "RU", currency: "RUB" },
  Rwanda: { code: "RW", currency: "RWF" },
  "Saint Barthelemy": { code: "BL", currency: "EUR" },
  "Saint Helena": { code: "SH", currency: "SHP" },
  "Saint Kitts And Nevis": { code: "KN", currency: "XCD" },
  "Saint Lucia": { code: "LC", currency: "XCD" },
  "Saint Martin": { code: "MF", currency: "EUR" },
  "Saint Pierre And Miquelon": { code: "PM", currency: "EUR" },
  "Saint Vincent And Grenadines": { code: "VC", currency: "XCD" },
  Samoa: { code: "WS", currency: "WST" },
  "San Marino": { code: "SM", currency: "EUR" },
  "Sao Tome And Principe": { code: "ST", currency: "STD" },
  "Saudi Arabia": { code: "SA", currency: "SAR" },
  Senegal: { code: "SN", currency: "XOF" },
  Serbia: { code: "RS", currency: "RSD" },
  Seychelles: { code: "SC", currency: "SCR" },
  "Sierra Leone": { code: "SL", currency: "SLL" },
  Singapore: { code: "SG", currency: "SGD" },
  Slovakia: { code: "SK", currency: "EUR" },
  Slovenia: { code: "SI", currency: "EUR" },
  "Solomon Islands": { code: "SB", currency: "SBD" },
  Somalia: { code: "SO", currency: "SOS" },
  "South Africa": { code: "ZA", currency: "ZAR" },
  "South Georgia And Sandwich Isl.": { code: "GS", currency: "GBP" },
  Spain: { code: "ES", currency: "EUR" },
  "Sri Lanka": { code: "LK", currency: "LKR" },
  Sudan: { code: "SD", currency: "SDD" },
  Suriname: { code: "SR", currency: "SRD" },
  "Svalbard and Jan Mayen": { code: "SJ", currency: "NOK" },
  Swaziland: { code: "SZ", currency: "SZL" },
  Sweden: { code: "SE", currency: "SEK" },
  Switzerland: { code: "CH", currency: "CHF" },
  "Syrian Arab Republic": { code: "SY", currency: "SYP" },
  Taiwan: { code: "TW", currency: "TWD" },
  Tajikistan: { code: "TJ", currency: "TJS" },
  Tanzania: { code: "TZ", currency: "TZS" },
  Thailand: { code: "TH", currency: "THB" },
  "Timor-Leste": { code: "TL", currency: "USD" },
  Togo: { code: "TG", currency: "XOF" },
  Tokelau: { code: "TK", currency: "NZD" },
  Tonga: { code: "TO", currency: "TOP" },
  "Trinidad And Tobago": { code: "TT", currency: "TTD" },
  Tunisia: { code: "TN", currency: "TND" },
  Turkey: { code: "TR", currency: "TRY" },
  Turkmenistan: { code: "TM", currency: "TMT" },
  "Turks And Caicos Islands": { code: "TC", currency: "USD" },
  Tuvalu: { code: "TV", currency: "AUD" },
  Uganda: { code: "UG", currency: "UGX" },
  Ukraine: { code: "UA", currency: "UAH" },
  "United Arab Emirates": { code: "AE", currency: "AED" },
  "United Kingdom": { code: "GB", currency: "GBP" },
  "United States": { code: "US", currency: "USD" },
  "United States Outlying Islands": { code: "UM", currency: "USD" },
  Uruguay: { code: "UY", currency: "UYU" },
  Uzbekistan: { code: "UZ", currency: "UZS" },
  Vanuatu: { code: "VU", currency: "VUV" },
  Venezuela: { code: "VE", currency: "VEF" },
  Vietnam: { code: "VN", currency: "VND" },
  "Virgin Islands, British": { code: "VG", currency: "USD" },
  "Virgin Islands, U.S.": { code: "VI", currency: "USD" },
  "Wallis And Futuna": { code: "WF", currency: "XPF" },
  "Western Sahara": { code: "EH", currency: "MAD" },
  Yemen: { code: "YE", currency: "YER" },
  Zambia: { code: "ZM", currency: "ZMW" },
  Zimbabwe: { code: "ZW", currency: "ZWL" },
} as const;

export type CountryCode =
  | "AC"
  | "AD"
  | "AE"
  | "AF"
  | "AG"
  | "AI"
  | "AL"
  | "AM"
  | "AO"
  | "AR"
  | "AS"
  | "AT"
  | "AU"
  | "AW"
  | "AX"
  | "AZ"
  | "BA"
  | "BB"
  | "BD"
  | "BE"
  | "BF"
  | "BG"
  | "BH"
  | "BI"
  | "BJ"
  | "BL"
  | "BM"
  | "BN"
  | "BO"
  | "BQ"
  | "BR"
  | "BS"
  | "BT"
  | "BW"
  | "BY"
  | "BZ"
  | "CA"
  | "CC"
  | "CD"
  | "CF"
  | "CG"
  | "CH"
  | "CI"
  | "CK"
  | "CL"
  | "CM"
  | "CN"
  | "CO"
  | "CR"
  | "CU"
  | "CV"
  | "CW"
  | "CX"
  | "CY"
  | "CZ"
  | "DE"
  | "DJ"
  | "DK"
  | "DM"
  | "DO"
  | "DZ"
  | "EC"
  | "EE"
  | "EG"
  | "EH"
  | "ER"
  | "ES"
  | "ET"
  | "FI"
  | "FJ"
  | "FK"
  | "FM"
  | "FO"
  | "FR"
  | "GA"
  | "GB"
  | "GD"
  | "GE"
  | "GF"
  | "GG"
  | "GH"
  | "GI"
  | "GL"
  | "GM"
  | "GN"
  | "GP"
  | "GQ"
  | "GR"
  | "GT"
  | "GU"
  | "GW"
  | "GY"
  | "HK"
  | "HN"
  | "HR"
  | "HT"
  | "HU"
  | "ID"
  | "IE"
  | "IL"
  | "IM"
  | "IN"
  | "IO"
  | "IQ"
  | "IR"
  | "IS"
  | "IT"
  | "JE"
  | "JM"
  | "JO"
  | "JP"
  | "KE"
  | "KG"
  | "KH"
  | "KI"
  | "KM"
  | "KN"
  | "KP"
  | "KR"
  | "KW"
  | "KY"
  | "KZ"
  | "LA"
  | "LB"
  | "LC"
  | "LI"
  | "LK"
  | "LR"
  | "LS"
  | "LT"
  | "LU"
  | "LV"
  | "LY"
  | "MA"
  | "MC"
  | "MD"
  | "ME"
  | "MF"
  | "MG"
  | "MH"
  | "MK"
  | "ML"
  | "MM"
  | "MN"
  | "MO"
  | "MP"
  | "MQ"
  | "MR"
  | "MS"
  | "MT"
  | "MU"
  | "MV"
  | "MW"
  | "MX"
  | "MY"
  | "MZ"
  | "NA"
  | "NC"
  | "NE"
  | "NF"
  | "NG"
  | "NI"
  | "NL"
  | "NO"
  | "NP"
  | "NR"
  | "NU"
  | "NZ"
  | "OM"
  | "PA"
  | "PE"
  | "PF"
  | "PG"
  | "PH"
  | "PK"
  | "PL"
  | "PM"
  | "PR"
  | "PS"
  | "PT"
  | "PW"
  | "PY"
  | "QA"
  | "RE"
  | "RO"
  | "RS"
  | "RU"
  | "RW"
  | "SA"
  | "SB"
  | "SC"
  | "SD"
  | "SE"
  | "SG"
  | "SH"
  | "SI"
  | "SJ"
  | "SK"
  | "SL"
  | "SM"
  | "SN"
  | "SO"
  | "SR"
  | "SS"
  | "ST"
  | "SV"
  | "SX"
  | "SY"
  | "SZ"
  | "TA"
  | "TC"
  | "TD"
  | "TG"
  | "TH"
  | "TJ"
  | "TK"
  | "TL"
  | "TM"
  | "TN"
  | "TO"
  | "TR"
  | "TT"
  | "TV"
  | "TW"
  | "TZ"
  | "UA"
  | "UG"
  | "US"
  | "UY"
  | "UZ"
  | "VA"
  | "VC"
  | "VE"
  | "VG"
  | "VI"
  | "VN"
  | "VU"
  | "WF"
  | "WS"
  | "XK"
  | "YE"
  | "YT"
  | "ZA"
  | "ZM"
  | "ZW";

export const countryNameToCodeMap = new Map<string, string>(
  Object.entries(countryCodeAndCurrency).map(([name, info]) => [
    name,
    info.code,
  ])
);

export const countryNameToCurrencyMap = new Map<string, string>(
  Object.entries(countryCodeAndCurrency).map(([name, info]) => [
    name,
    info.currency,
  ])
);

export const codeToCountryNameMap = new Map<string, string>(
  Object.entries(countryCodeAndCurrency).map(([name, info]) => [
    info.code,
    name,
  ])
);

export enum AccountCurrencyTypeEnum {
  USD = "USD",
  SGD = "SGD",
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ARS = "ARS",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BWP = "BWP",
  BYN = "BYN",
  BZD = "BZD",
  CAD = "CAD",
  CHF = "CHF",
  CLP = "CLP",
  CNH = "CNH",
  COP = "COP",
  CDF = "CDF",
  CRC = "CRC",
  CUP = "CUP",
  ANG = "ANG",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  FJD = "FJD",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  HKD = "HKD",
  HNL = "HNL",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KHR = "KHR",
  KMF = "KMF",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LYD = "LYD",
  MDL = "MDL",
  EUR = "EUR",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MOP = "MOP",
  MRO = "MRO",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SCR = "SCR",
  SDD = "SDD",
  SEK = "SEK",
  SHP = "SHP",
  SLL = "SLL",
  SOS = "SOS",
  SSP = "SSP",
  STD = "STD",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TND = "TND",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  AUD = "AUD",
  UAH = "UAH",
  UGX = "UGX",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VND = "VND",
  MAD = "MAD",
  XAF = "XAF",
  XCD = "XCD",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZWL = "ZWL",
}
